import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL_LOCAL,
    withCredentials: true
});

api.interceptors.request.use((config) => {
    const anonId = localStorage.getItem('anon_id');
    if (anonId) {
        config.headers['x-anonymous-id'] = anonId;
    }
    return config;
});

export default api;